import type { TripItineraryItem, TripItemWithoutDay } from 'tripPlanner/api/types'

export function isActivityPlaceholder(item: TripItineraryItem | TripItemWithoutDay): boolean {
  return item.type === 'ATTRACTION' && item.isPlaceLookupApplicable === false
}
